export enum FederalAgency {
    OfficeoftheComptrolleroftheCurrency = 1,
    FederalReserveSystem = 2,
    FederalDepositInsuranceCorporation = 3,
    NationalCreditUnionAdministration = 5,
    UnitedStatesDepartmentOfHousingandUrbanDevelopment = 7,
    ConsumerFinancialProtectionBureau = 9,
}
